/** @jsxImportSource @emotion/react */

import React from 'react';
import Begin from '@component/iyagigo/home/begin';
import PageTemplate from '@page/iyagigo/page-template';
import Scroll from '@component/common/scroll';
import * as color from '@constant/color';
import { useTodayDataInit } from '@hook/iyagigo/useInit';
import TodayDataInitScreen from '@component/iyagigo/common/today-data-init-screen';

const BeginPage: React.FC = () => {
  const isTodayDataInitialized = useTodayDataInit();

  const HEADER_TITLE = '시작하기';

  return (
    <>
      {!isTodayDataInitialized && <TodayDataInitScreen />}
      <PageTemplate title={HEADER_TITLE} mode={'page'} backgroundColor={color.GRAY_BACKGROUND_COLOR}>
        <Scroll direction='y' height={`calc(100% - 10px)`}>
          <Begin />
        </Scroll>
      </PageTemplate>
    </>
  );
};

export default BeginPage;
